import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var PenTool02 = function PenTool02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M13 5.9999 6.5018 7.2995c-.363.0726-.5445.1089-.6923.1971a1 1 0 0 0-.3249.3124c-.094.1442-.1375.3241-.2243.684L2 21.9998m0 0 13.5069-3.2602c.3598-.0869.5397-.1303.6839-.2243a1 1 0 0 0 .3124-.325c.0883-.1478.1246-.3293.1972-.6923L18 10.9998m-16 11 7.586-7.586m11.2826-6.5453-4.7372-4.7373c-.396-.396-.5941-.594-.8224-.6682a1 1 0 0 0-.618 0c-.2283.0742-.4264.2722-.8224.6682l-.7372.7373c-.396.396-.5941.594-.6682.8223a1 1 0 0 0 0 .618c.0741.2284.2722.4264.6682.8224l4.7372 4.7373c.396.396.5941.594.8224.6682.2008.0652.4172.0652.618 0 .2283-.0742.4264-.2722.8224-.6682l.7372-.7373c.396-.396.5941-.594.6682-.8223a1 1 0 0 0 0-.618c-.0741-.2284-.2722-.4264-.6682-.8224M11 10.9998c1.1046 0 2 .8955 2 2s-.8954 2-2 2-2-.8954-2-2 .8954-2 2-2"
    })
  }));
};
export default PenTool02;